// TODO: Restrict the signature of the t function to only accept keys with explicit namespaces
import { t as importedTFn, type TFunction } from 'i18next';
import { useTranslation as importedHook } from 'react-i18next';

type TranslationKey = `${string}:${string}`;

export const useTranslation = (ns: string) => importedHook<string>(ns);
export const t: TFunction<string> = importedTFn;
